module.exports = __webpack_public_path__ + "mm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mm.svg
// module id = 948
// module chunks = 0